import React from "react";
import "../Styles/Mission.css";
import MissionImg1 from "../assets/mission-img1.svg";
import MissionImg2 from "../assets/mission-img2.svg";
import MissionImg3 from "../assets/mission-img3.svg";

const Mission = () => {
  return (
    <section className="mission">
      <div className="container">
        <div className="mission-head reveal">
          <p className="eyebrow">For parents</p>
          <h2 className="section-title">Does this sound familiar?</h2>
          <p className="section-lead">
            Most families reach out when school starts feeling heavier than it should.
            You are not alone — and you do not have to figure it out alone.
          </p>
        </div>

        <div className="mission-grid stagger">
          <article className="mission-item reveal">
            <img src={MissionImg1} alt="" />
            <h3>Concepts aren’t sticking</h3>
            <p>
              Your student studies hard, but tests still feel confusing and confidence slips.
            </p>
          </article>
          <article className="mission-item reveal">
            <img src={MissionImg2} alt="" />
            <h3>Time is running out</h3>
            <p>
              Deadlines, exams, and busy schedules leave little room to catch up without support.
            </p>
          </article>
          <article className="mission-item reveal">
            <img src={MissionImg3} alt="" />
            <h3>School feels overwhelming</h3>
            <p>
              Stress builds, motivation drops, and evenings turn into frustration for everyone.
            </p>
          </article>
        </div>

        <p className="mission-close reveal">
          That’s where True Bloom comes in — calm, personal support that rebuilds confidence.
        </p>
      </div>
    </section>
  );
};

export default Mission;
